// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
let products = [
  {
    key: "modelStatus",
    image: "model-status-expanded",
    imageCollapsed: "mimo-claw-collapsed-v5",
    href: "https://www.15token.win/monitor",
    trackName: "modelstatus",
  },
  {
    key: "apiKeys",
    image: "api-keys-expanded",
    imageCollapsed: "api-collapsed-v5",
    href: "https://www.15token.win/keys",
    trackName: "apikeys",
  },
  {
    key: "usage",
    image: "usage-expanded",
    imageCollapsed: "desktop-collapsed-v4",
    href: "https://www.15token.win/usage",
    trackName: "usage",
  },
  {
    key: "dashboard",
    image: "dashboard-expanded",
    imageCollapsed: "mimo-code-collapsed-v5",
    href: "https://www.15token.win/dashboard",
    trackName: "dashboard",
  },
];
export { products };
